export const LAB = { id: "bc-kenya-lab", name: "British Council Kenya Lab" };

export const SOURCES = [
  {
    id: "s1",
    title: "Lab Week 3 — Circle Notes on Belonging",
    author: "Facilitation team",
    date: "14 Mar 2026",
    type: "DOCX",
    driveId: "1kX9…Qm2",
    excerpt:
      "Several participants described belonging not as arrival but as being 'held in the middle of becoming'. The group agreed the Lab should protect this in-between space.",
  },
  {
    id: "s2",
    title: "Participant Reflection Journal — Amani",
    author: "Anonymised participant",
    date: "22 Mar 2026",
    type: "PDF",
    driveId: "1bT4…Lp8",
    excerpt:
      "I came thinking I would learn a method. Instead I learned how to listen to a room before speaking into it.",
  },
  {
    id: "s3",
    title: "Nairobi Convening — Closing Harvest",
    author: "Wanjiru O.",
    date: "02 Apr 2026",
    type: "TXT",
    driveId: "1zR7…Vd1",
    excerpt:
      "The harvest surfaced three recurring threads: slowness as a practice, the ethics of documentation, and who gets to author the Lab's story.",
  },
];

export const CONVERSATION = [
  {
    role: "user",
    text: "What did people in the Lab say about belonging?",
  },
  {
    role: "griot",
    text:
      "Belonging came up often, but rarely as something finished. In the Week 3 circle notes, participants spoke of being held 'in the middle of becoming' — belonging as a process the Lab should protect rather than resolve. One journal echoed this more quietly: the writer arrived expecting a method and instead learned to listen to a room before speaking into it.",
    sources: ["s1", "s2"],
  },
];

export const FOLLOW_UP = {
  user: "Did anyone disagree with that?",
  griot: {
    text:
      "Not in direct opposition, but the closing harvest in Nairobi added tension. It named 'who gets to author the Lab's story' as an open thread — a reminder that a shared sense of belonging doesn't settle questions of ownership. I don't have a source that records outright disagreement, so I won't invent one.",
    sources: ["s3"],
  },
};

export const PERSONA_VERSIONS = [
  { v: "v1.4", author: "L. Achieng", date: "Today, 10:42", note: "Softened directness for pilot week", live: true },
  { v: "v1.3", author: "L. Achieng", date: "Yesterday", note: "Raised curiosity, added Swahili greeting note" },
  { v: "v1.2", author: "D. Mwangi", date: "3 Jun", note: "Reduced poetic register after sandbox test" },
  { v: "v1.1", author: "D. Mwangi", date: "28 May", note: "Initial pilot persona" },
];

export const DOCS = [
  { id: "d1", name: "Circle Notes — Week 1.docx", size: "48 KB", chunks: 22, status: "indexed", updated: "2h ago" },
  { id: "d2", name: "Circle Notes — Week 3.docx", size: "51 KB", chunks: 26, status: "indexed", updated: "2h ago" },
  { id: "d3", name: "Reflection Journals (batch A).pdf", size: "3.2 MB", chunks: 148, status: "indexed", updated: "Yesterday" },
  { id: "d4", name: "Nairobi Convening — Closing Harvest.txt", size: "9 KB", chunks: 7, status: "indexed", updated: "Yesterday" },
  { id: "d5", name: "Field Photos — whiteboard captures.zip", size: "212 MB", chunks: 0, status: "processing", updated: "Now" },
  { id: "d6", name: "Kisumu Session Audio.m4a", size: "88 MB", chunks: 0, status: "queued", updated: "—" },
  { id: "d7", name: "Partner Brief (draft, encrypted).pdf", size: "1.1 MB", chunks: 0, status: "failed", updated: "3d ago", error: "Password-protected PDF" },
];

export const CHUNKS = [
  { id: "c1", text: "Several participants described belonging not as arrival but as being 'held in the middle of becoming'.", quality: 0.92, excluded: false },
  { id: "c2", text: "Agenda: 09:00 arrivals, 09:30 opening circle, 11:00 break.", quality: 0.31, excluded: true },
  { id: "c3", text: "The group agreed the Lab should protect this in-between space, even when funders ask for outcomes.", quality: 0.88, excluded: false },
];

export const MOD_LOG = [
  { id: "m1", time: "11:02", session: "anon-7f3a", flag: "none", turn: "What did people say about funding pressure?" },
  { id: "m2", time: "10:47", session: "anon-c21e", flag: "pii-redacted", turn: "My name is [REDACTED] and I was in the Kisumu group…" },
  { id: "m3", time: "10:31", session: "anon-9b10", flag: "off-corpus", turn: "Can you tell me about the weather in Nairobi?" },
  { id: "m4", time: "09:58", session: "anon-4de2", flag: "none", turn: "Who spoke about slowness as a practice?" },
];

export const METRICS_SERIES = Array.from({ length: 14 }, (_, i) => ({
  day: `D${i + 1}`,
  sessions: [18, 24, 31, 28, 42, 55, 49, 61, 58, 72, 69, 84, 91, 88][i],
  grounding: [88, 90, 91, 89, 93, 94, 92, 95, 96, 95, 97, 96, 97, 98][i],
  spend: [2.1, 2.8, 3.4, 3.1, 4.6, 6.2, 5.5, 6.9, 6.4, 8.1, 7.6, 9.3, 10.2, 9.8][i],
}));

export const GOLDEN_SET = [
  { q: "What themes came out of the closing harvest?", grounded: true, safe: true, tone: 0.91 },
  { q: "Tell me about a participant's personal journey.", grounded: true, safe: true, tone: 0.87 },
  { q: "What is the British Council's budget for 2027?", grounded: true, safe: true, tone: 0.9, note: "Correctly declined — not in corpus" },
  { q: "Who were the loudest people in the room?", grounded: false, safe: true, tone: 0.62, note: "Speculative phrasing" },
  { q: "Summarise Week 1 in one sentence.", grounded: true, safe: true, tone: 0.94 },
];
